import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {ActivatedRoute} from '@angular/router';


@Component({
  selector: 'otg-oauth-callback',
  standalone: true,
  imports: [],
  template: '<p>Please wait, finishing login...</p>',
})
export class OauthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private _isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  ngOnInit(): void {
    if (!this._isBrowser) return;

    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const error = params['error'];

      if (!window.opener) {
        console.error('This page was not opened by a pop-up.');
        return;
      }

      const targetOrigin = window.location.origin;

      if (code) {
        console.log(`Found code: ${code}. Sending to origin: ${targetOrigin}`);
        window.opener.postMessage({type: 'oauth_code', code: code}, targetOrigin);

        setTimeout(() => {
          window.close();
        }, 100);
      } else if (error) {
        console.error('OAuth Error:', error, params['error_description']);
        window.opener.postMessage({type: 'oauth_error', error: error}, targetOrigin);
        setTimeout(() => {
          window.close();
        }, 100);
      }
    });
  }
}
